module.exports = __webpack_public_path__ + "img/ticket.1e8be0a1.png";